import { api } from '@shared/config/axios';

export default {
  getSSORegisterUrl() {
    return api.$post('/oauth/sso-redirect');
  },
  getSSOLoginUrl() {
    return api.$post('/oauth/sso-login');
  },
  disconnect() {
    return api.$delete('/talkizy/connection');
  },
  getPlan() {
    return api.$get('/talkizy/plan');
  },
  getTeamContext() {
    return api.$get('/talkizy/team-context');
  },
  getMembers() {
    return api.$get('/talkizy/members');
  },
  switchTeam(teamId) {
    return api.$post('/talkizy/current-team', { team_id: teamId });
  },
  getStatus() {
    return api.$get('/talkizy/status');
  },
  getJoinUrl() {
    return api.$post('/oauth/sso-join');
  },
  createMeeting(payload) {
    return api.$post('/talkizy/meetings', payload);
  },
  listMeetings(params = {}) {
    return api.$get('/talkizy/meetings', { params });
  },
  getMeeting(id) {
    return api.$get(`/talkizy/meetings/${id}`);
  },
  getMeetingParticipants(id) {
    return api.$get(`/talkizy/meetings/${id}/participants`);
  },
  addMeetingParticipants(id, participants, role = null) {
    const body = { participants };
    if (role) {
      body.role = role;
    }
    return api.$post(`/talkizy/meetings/${id}/participants`, body);
  },
  exportMeetingRegistrations(id) {
    return api.get(`/talkizy/meetings/${id}/registrations/export`, { responseType: 'blob' });
  },
  updateMeeting(id, payload) {
    return api.$patch(`/talkizy/meetings/${id}`, payload);
  },
  cancelMeeting(id) {
    return api.$delete(`/talkizy/meetings/${id}`);
  },
  deleteMeeting(id) {
    return api.$delete(`/talkizy/meetings/${id}/delete`);
  },
  getLearnerParticipations(email) {
    return api.$get(`/talkizy/learners/${encodeURIComponent(email)}/participations`);
  },
};
